import React from 'react';
import Flag from '@atlaskit/flag';
import InfoIcon from '@atlaskit/icon/glyph/check-circle';
import { B300 } from '@atlaskit/theme/colors';
const RefreshBanner = ({
  reloadEP,
  title,
  actionLabel
}) => /*#__PURE__*/React.createElement(Flag, {
  icon: /*#__PURE__*/React.createElement(InfoIcon, {
    primaryColor: `var(--ds-icon-information, ${B300})`,
    label: "Info"
  }),
  id: "refreshBanner",
  title: title,
  actions: [{
    content: actionLabel,
    onClick: reloadEP
  }]
});
export default RefreshBanner;